// AUTO-GENERATED by scripts/gen-worldcup-flags.cjs (do not edit by hand).
// Maps a country name — as it appears in World Cup "team1"/"team2" props — to a
// flag code under public/flags/<code>.svg. Built from the world-countries ISO
// dataset plus a FIFA alias layer (England/Scotland/Wales/Northern Ireland,
// Türkiye/Turkey, Congo vs DR Congo, Korea Republic/DPR, Iran, Côte d'Ivoire…).
//
// Lookups are diacritic- and punctuation-insensitive, so "Türkiye", "Turkiye",
// and "Turkey" all resolve to the same flag, and an unknown name returns null
// rather than throwing.

// Keep this in sync with the normalize() used by the generator.
export function normalizeCountry(name: string): string {
  return (name || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/['\u2019.]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');
}

// normalizedName -> flag code (filename stem under public/flags).
export const FLAG_CODE_BY_COUNTRY: Record<string, string> = {
  aaland: 'ax',
  afganistan: 'af',
  afghanistan: 'af',
  ahvenanmaa: 'ax',
  aland: 'ax',
  alandislands: 'ax',
  albania: 'al',
  algeria: 'dz',
  algerie: 'dz',
  alittihadalqumuri: 'km',
  aljumhuriyahalarabiyahassuriyah: 'sy',
  aljumhuriyahallibnaniyah: 'lb',
  aljumhuriyyahalislamiyyahalmuritaniyyah: 'mr',
  aljumhuriyyahalyamaniyyah: 'ye',
  aljumhuriyyahattunisiyyah: 'tn',
  almamlakahalarabiyyahassuudiyyah: 'sa',
  almamlakahalmagribiyah: 'ma',
  almamlakahalurduniyahalhashimiyah: 'jo',
  amelikasamoa: 'as',
  america: 'us',
  americansamoa: 'as',
  amerikasamoa: 'as',
  andorra: 'ad',
  angola: 'ao',
  anguilla: 'ai',
  antarctica: 'aq',
  antiguaandbarbuda: 'ag',
  aolepanaorokinmajel: 'mh',
  aotearoa: 'nz',
  arabrepublicofegypt: 'eg',
  argentina: 'ar',
  argentinerepublic: 'ar',
  armenia: 'am',
  aruba: 'aw',
  assumal: 'so',
  australia: 'au',
  austria: 'at',
  azerbaijan: 'az',
  azrbaycanrespublikas: 'az',
  bahamas: 'bs',
  bahrain: 'bh',
  bailiwickofguernsey: 'gg',
  bailiwickofjersey: 'je',
  bailliagedeguernesey: 'gg',
  bailliagedejerri: 'je',
  bailliagedejersey: 'je',
  bangladesh: 'bd',
  barbados: 'bb',
  belarus: 'by',
  belgie: 'be',
  belgien: 'be',
  belgique: 'be',
  belgium: 'be',
  belize: 'bz',
  beluuerabelau: 'pw',
  benin: 'bj',
  bermuda: 'bm',
  besislands: 'bq',
  bharat: 'in',
  bharatganrajya: 'in',
  bhutan: 'bt',
  bielarus: 'by',
  bolivarianrepublicofvenezuela: 've',
  bolivia: 'bo',
  boliviaplurinationalstateof: 'bo',
  bonairesinteustatiusandsaba: 'bq',
  bosnia: 'ba',
  bosniaandherzegovina: 'ba',
  bosniaherzegovina: 'ba',
  botswana: 'bw',
  bouvetisland: 'bv',
  bouvetya: 'bv',
  brasil: 'br',
  brazil: 'br',
  britishindianoceanterritory: 'io',
  britishvirginislands: 'vg',
  brunei: 'bn',
  bruneidarussalam: 'bn',
  bulgaria: 'bg',
  buliwya: 'bo',
  buliwyamamallaqta: 'bo',
  bundesrepublikdeutschland: 'de',
  burkinafaso: 'bf',
  burma: 'mm',
  burundi: 'bi',
  caboverde: 'cv',
  cambodia: 'kh',
  cameroon: 'cm',
  canada: 'ca',
  capeverde: 'cv',
  caribbeannetherlands: 'bq',
  caymanislands: 'ky',
  centralafricanrepublic: 'cf',
  ceskarepublika: 'cz',
  cesko: 'cz',
  chad: 'td',
  chile: 'cl',
  china: 'cn',
  chinesetaipei: 'tw',
  chosonminjujuuiinminkonghwaguk: 'kp',
  christmasisland: 'cx',
  cocosislands: 'cc',
  cocoskeelingislands: 'cc',
  collectivitedesaintbarthelemy: 'bl',
  collectivitedesaintmartin: 'mf',
  collectiviteterritorialedesaintpierreetmiquelon: 'pm',
  collectivityofsaintbarthelemy: 'bl',
  collectivityofsaintmartin: 'mf',
  colombia: 'co',
  commonwealthofaustralia: 'au',
  commonwealthofdominica: 'dm',
  commonwealthofpuertorico: 'pr',
  commonwealthofthebahamas: 'bs',
  commonwealthofthenorthernmarianaislands: 'mp',
  comoros: 'km',
  conghoaxahoichunghiavietnam: 'vn',
  congo: 'cg',
  congobrazzaville: 'cg',
  congodr: 'cd',
  congokinshasa: 'cd',
  congothedemocraticrepublicofthe: 'cd',
  cookislands: 'ck',
  cooperativerepublicofguyana: 'gy',
  costarica: 'cr',
  cotedivoire: 'ci',
  countryofcuracao: 'cw',
  crnagora: 'me',
  croatia: 'hr',
  cuba: 'cu',
  cumhuriyitocikiston: 'tj',
  curacao: 'cw',
  cyprus: 'cy',
  czechia: 'cz',
  czechrepublic: 'cz',
  danmark: 'dk',
  dawlatalkuwait: 'kw',
  dawlatfilastin: 'ps',
  dawlatiritriya: 'er',
  dawlatlibya: 'ly',
  dawlatqatar: 'qa',
  democraticpeoplesrepublicofkorea: 'kp',
  democraticrepublicofcongo: 'cd',
  democraticrepublicofsaotomeandprincipe: 'st',
  democraticrepublicofthecongo: 'cd',
  democraticrepublicoftimorleste: 'tl',
  democraticsocialistrepublicofsrilanka: 'lk',
  denmark: 'dk',
  departementdemayotte: 'yt',
  departmentofmayotte: 'yt',
  dhivehiraajjeygejumhooriyya: 'mv',
  djibouti: 'dj',
  dominica: 'dm',
  dominicanrepublic: 'do',
  dominique: 'dm',
  dprk: 'kp',
  dprkorea: 'kp',
  drc: 'cd',
  drcongo: 'cd',
  dzayer: 'dz',
  easttimor: 'tl',
  ecuador: 'ec',
  eesti: 'ee',
  eestivabariik: 'ee',
  egypt: 'eg',
  eire: 'ie',
  ellada: 'gr',
  ellanvannin: 'im',
  elsalvador: 'sv',
  emirates: 'ae',
  england: 'gb-eng',
  equatorialguinea: 'gq',
  eritrea: 'er',
  ertra: 'er',
  estadolibreasociadodepuertorico: 'pr',
  estadoplurinacionaldebolivia: 'bo',
  estadosunidosmexicanos: 'mx',
  estonia: 'ee',
  eswatini: 'sz',
  ethiopia: 'et',
  faeroeislands: 'fo',
  falklandislands: 'fk',
  falklandislandsmalvinas: 'fk',
  faroeislands: 'fo',
  federaldemocraticrepublicofethiopia: 'et',
  federaldemocraticrepublicofnepal: 'np',
  federalrepublicofgermany: 'de',
  federalrepublicofnigeria: 'ng',
  federalrepublicofsomalia: 'so',
  federatedstatesofmicronesia: 'fm',
  federationofsaintchristopherandnevis: 'kn',
  federativerepublicofbrazil: 'br',
  fiji: 'fj',
  fijiganarajya: 'fj',
  finland: 'fi',
  france: 'fr',
  frenchguiana: 'gf',
  frenchpolynesia: 'pf',
  frenchrepublic: 'fr',
  frenchsouthernandantarcticlands: 'tf',
  frenchsouthernterritories: 'tf',
  frerne: 'fo',
  froyar: 'fo',
  furstentumliechtenstein: 'li',
  gabon: 'ga',
  gaboneserepublic: 'ga',
  gabuuti: 'dj',
  gabuutihummuuno: 'dj',
  gambia: 'gm',
  georgia: 'ge',
  germany: 'de',
  ghana: 'gh',
  gibraltar: 'gi',
  gonoprojatontribangladesh: 'bd',
  grandduchedeluxembourg: 'lu',
  grandduchyofluxembourg: 'lu',
  greatbritain: 'gb',
  greece: 'gr',
  greenland: 'gl',
  grenada: 'gd',
  grnland: 'gl',
  groherzogtumluxemburg: 'lu',
  groussherzogtumletzebuerg: 'lu',
  guadeloupe: 'gp',
  guahan: 'gu',
  guam: 'gu',
  guatemala: 'gt',
  guernsey: 'gg',
  guiana: 'gf',
  guinea: 'gn',
  guineabissau: 'gw',
  guyana: 'gy',
  guyane: 'gf',
  gwadloup: 'gp',
  haiti: 'ht',
  hashemitekingdomofjordan: 'jo',
  hayastan: 'am',
  heardislandandmcdonaldislands: 'hm',
  hellenicrepublic: 'gr',
  holland: 'nl',
  holyseevaticancitystate: 'va',
  honduras: 'hn',
  hongkong: 'hk',
  hongkongspecialadministrativeregionofthepeoplesrepublicofchina: 'hk',
  hrvatska: 'hr',
  hungary: 'hu',
  iceland: 'is',
  ilankai: 'lk',
  independenstetbilongpapuaniugini: 'pg',
  independentandsovereignrepublicofkiribati: 'ki',
  independentstateofpapuanewguinea: 'pg',
  independentstateofsamoa: 'ws',
  india: 'in',
  indonesia: 'id',
  iran: 'ir',
  iranislamicrepublicof: 'ir',
  iraq: 'iq',
  ireland: 'ie',
  iriran: 'ir',
  iritriya: 'er',
  islamicrepublicofafghanistan: 'af',
  islamicrepublicofiran: 'ir',
  islamicrepublicofmauritania: 'mr',
  islamicrepublicofpakistan: 'pk',
  islamijumhuriyaehpakistan: 'pk',
  island: 'is',
  islasmalvinas: 'fk',
  isleofman: 'im',
  israel: 'il',
  italianrepublic: 'it',
  italy: 'it',
  ityoppya: 'et',
  ivorycoast: 'ci',
  jabuuti: 'dj',
  jamaica: 'jm',
  jamhuriyakenya: 'ke',
  jamhuriyamuunganowatanzania: 'tz',
  jamhuriyauganda: 'ug',
  jamhuuriyaddafederaalkasoomaaliya: 'so',
  jamhuuriyaddajabuuti: 'dj',
  japan: 'jp',
  jersey: 'je',
  jomhuriyeeslamiyeiran: 'ir',
  jordan: 'jo',
  jumhuriyatassudan: 'sd',
  jumhuriyyataliraq: 'iq',
  jumhuriyyatassumalalfideraliyya: 'so',
  kazakhstan: 'kz',
  kbrs: 'cy',
  kbrscumhuriyeti: 'cy',
  keelingislands: 'cc',
  kenya: 'ke',
  kingdomofbahrain: 'bh',
  kingdomofbelgium: 'be',
  kingdomofbhutan: 'bt',
  kingdomofcambodia: 'kh',
  kingdomofdenmark: 'dk',
  kingdomofeswatini: 'sz',
  kingdomoflesotho: 'ls',
  kingdomofmorocco: 'ma',
  kingdomofnorway: 'no',
  kingdomofsaudiarabia: 'sa',
  kingdomofspain: 'es',
  kingdomofsweden: 'se',
  kingdomofthailand: 'th',
  kingdomofthenetherlands: 'nl',
  kingdomoftonga: 'to',
  kiribati: 'ki',
  kongerigetdanmark: 'dk',
  kongeriketnoreg: 'no',
  kongeriketnorge: 'no',
  konigreichbelgien: 'be',
  koninkrijkbelgie: 'be',
  konungariketsverige: 'se',
  korea: 'kr',
  koreademocraticpeoplesrepublicof: 'kp',
  koreadpr: 'kp',
  korearepublic: 'kr',
  korearepublicof: 'kr',
  korsou: 'cw',
  kosovo: 'xk',
  kukiairani: 'ck',
  kuwait: 'kw',
  kypros: 'cy',
  kyrgyzrepublic: 'kg',
  kyrgyzrespublikasy: 'kg',
  kyrgyzstan: 'kg',
  landcuracao: 'cw',
  laopeoplesdemocraticrepublic: 'la',
  laos: 'la',
  latvia: 'lv',
  latvijasrepublika: 'lv',
  lebaneserepublic: 'lb',
  lebanon: 'lb',
  lefatshelabotswana: 'bw',
  lesotho: 'ls',
  liberia: 'lr',
  libya: 'ly',
  liechtenstein: 'li',
  lietuvosrespublika: 'lt',
  lithuania: 'lt',
  loktantrikganatantranepal: 'np',
  luxembourg: 'lu',
  lyveldiisland: 'is',
  macao: 'mo',
  macaospecialadministrativeregionofthepeoplesrepublicofchina: 'mo',
  macau: 'mo',
  macedonia: 'mk',
  macedoniatheformeryugoslavrepublicof: 'mk',
  madagascar: 'mg',
  malawi: 'mw',
  malaysia: 'my',
  maldiveislands: 'mv',
  maldives: 'mv',
  mali: 'ml',
  malosaolototutoatasiosamoa: 'ws',
  malta: 'mt',
  mamlakatalbahrayn: 'bh',
  mann: 'im',
  mannin: 'im',
  marshallislands: 'mh',
  martinique: 'mq',
  matanitukoviti: 'fj',
  mauritania: 'mr',
  mauritius: 'mu',
  mayotte: 'yt',
  medinatyisrael: 'il',
  mexicanos: 'mx',
  mexico: 'mx',
  micronesia: 'fm',
  micronesiafederatedstatesof: 'fm',
  moldova: 'md',
  moldovarepublicof: 'md',
  monaco: 'mc',
  mongolia: 'mn',
  montenegro: 'me',
  montserrat: 'ms',
  morocco: 'ma',
  mostserenerepublicofsanmarino: 'sm',
  mozambique: 'mz',
  musooalesotho: 'ls',
  myanmar: 'mm',
  naijiria: 'ng',
  namibia: 'na',
  namibie: 'na',
  naoero: 'nr',
  nationofbrunei: 'bn',
  nationofbruneiabodeofpeace: 'bn',
  nauru: 'nr',
  nederland: 'nl',
  nepal: 'np',
  netherlands: 'nl',
  newcaledonia: 'nc',
  newzealand: 'nz',
  ngwane: 'sz',
  nicaragua: 'ni',
  niger: 'ne',
  nigeria: 'ng',
  nihon: 'jp',
  nijar: 'ne',
  nijeriya: 'ng',
  nippon: 'jp',
  niue: 'nu',
  noreg: 'no',
  norfolkisland: 'nf',
  norge: 'no',
  northernireland: 'gb-nir',
  northernmarianaislands: 'mp',
  northkorea: 'kp',
  northmacedonia: 'mk',
  norway: 'no',
  oesterreich: 'at',
  oman: 'om',
  orientalrepublicofuruguay: 'uy',
  osterreich: 'at',
  ozbekistonrespublikasi: 'uz',
  paiskorsou: 'cw',
  pakistan: 'pk',
  palau: 'pw',
  palestine: 'ps',
  palestinestateof: 'ps',
  panama: 'pa',
  papuanewguinea: 'pg',
  paraguay: 'py',
  peoplesdemocraticrepublicofalgeria: 'dz',
  peoplesrepublicofbangladesh: 'bd',
  peoplesrepublicofchina: 'cn',
  peru: 'pe',
  philippines: 'ph',
  pitcairn: 'pn',
  pitcairngroupofislands: 'pn',
  pitcairnhendersonducieandoenoislands: 'pn',
  pitcairnislands: 'pn',
  pleasantisland: 'nr',
  plurinationalstateofbolivia: 'bo',
  poblachtnaheireann: 'ie',
  poland: 'pl',
  polynesiefrancaise: 'pf',
  porinetiafarani: 'pf',
  portugal: 'pt',
  portuguesa: 'pt',
  portugueserepublic: 'pt',
  prathet: 'th',
  principalityofandorra: 'ad',
  principalityofliechtenstein: 'li',
  principalityofmonaco: 'mc',
  principatdandorra: 'ad',
  principautedemonaco: 'mc',
  publikadeanla: 'ao',
  puertorico: 'pr',
  pyidaunzuthanmadamyamanainngandaw: 'mm',
  qatar: 'qa',
  qazaqstan: 'kz',
  qazaqstanrespublikas: 'kz',
  ratchaanachakthai: 'th',
  regiaoadministrativaespecialdemacaudarepublicapopulardachina: 'mo',
  reinodeespana: 'es',
  repiblikayiti: 'ht',
  repibliksesel: 'sc',
  repoblikanimadagasikara: 'mg',
  repubblicadisanmarino: 'sm',
  repubblicaitaliana: 'it',
  repubblikatamalta: 'mt',
  republicaargentina: 'ar',
  republicabolivarianadevenezuela: 've',
  republicadaguinebissau: 'gw',
  republicadaguineequatorial: 'gq',
  republicadeangola: 'ao',
  republicadecaboverde: 'cv',
  republicadechile: 'cl',
  republicadecolombia: 'co',
  republicadecostarica: 'cr',
  republicadecuba: 'cu',
  republicadeelsalvador: 'sv',
  republicadeguineaecuatorial: 'gq',
  republicadehonduras: 'hn',
  republicadelecuador: 'ec',
  republicadelparaguay: 'py',
  republicadelperu: 'pe',
  republicademocambique: 'mz',
  republicademocraticadesaotomeeprincipe: 'st',
  republicademocraticadetimorleste: 'tl',
  republicadenicaragua: 'ni',
  republicadepanama: 'pa',
  republicafederativadobrasil: 'br',
  republicamoldova: 'md',
  republicaorientaldeluruguay: 'uy',
  republicaportuguesa: 'pt',
  republicofalbania: 'al',
  republicofangola: 'ao',
  republicofarmenia: 'am',
  republicofaustria: 'at',
  republicofazerbaijan: 'az',
  republicofbelarus: 'by',
  republicofbenin: 'bj',
  republicofbotswana: 'bw',
  republicofbulgaria: 'bg',
  republicofburundi: 'bi',
  republicofcaboverde: 'cv',
  republicofcameroon: 'cm',
  republicofchad: 'td',
  republicofchile: 'cl',
  republicofchina: 'tw',
  republicofchinataiwan: 'tw',
  republicofcolombia: 'co',
  republicofcostarica: 'cr',
  republicofcotedivoire: 'ci',
  republicofcroatia: 'hr',
  republicofcuba: 'cu',
  republicofcyprus: 'cy',
  republicofdjibouti: 'dj',
  republicofecuador: 'ec',
  republicofelsalvador: 'sv',
  republicofequatorialguinea: 'gq',
  republicofestonia: 'ee',
  republicoffiji: 'fj',
  republicoffinland: 'fi',
  republicofghana: 'gh',
  republicofguatemala: 'gt',
  republicofguinea: 'gn',
  republicofguineabissau: 'gw',
  republicofhaiti: 'ht',
  republicofhonduras: 'hn',
  republicoficeland: 'is',
  republicofindia: 'in',
  republicofindonesia: 'id',
  republicofiraq: 'iq',
  republicofireland: 'ie',
  republicofkazakhstan: 'kz',
  republicofkenya: 'ke',
  republicofkiribati: 'ki',
  republicofkorea: 'kr',
  republicofkosovo: 'xk',
  republicoflatvia: 'lv',
  republicofliberia: 'lr',
  republicoflithuania: 'lt',
  republicofmadagascar: 'mg',
  republicofmalawi: 'mw',
  republicofmali: 'ml',
  republicofmalta: 'mt',
  republicofmauritius: 'mu',
  republicofmoldova: 'md',
  republicofmozambique: 'mz',
  republicofnamibia: 'na',
  republicofnauru: 'nr',
  republicofnicaragua: 'ni',
  republicofniger: 'ne',
  republicofnorthmacedonia: 'mk',
  republicofpalau: 'pw',
  republicofpanama: 'pa',
  republicofparaguay: 'py',
  republicofperu: 'pe',
  republicofpoland: 'pl',
  republicofrwanda: 'rw',
  republicofsanmarino: 'sm',
  republicofsenegal: 'sn',
  republicofserbia: 'rs',
  republicofseychelles: 'sc',
  republicofsierraleone: 'sl',
  republicofsingapore: 'sg',
  republicofslovenia: 'si',
  republicofsouthafrica: 'za',
  republicofsouthsudan: 'ss',
  republicofsuriname: 'sr',
  republicoftajikistan: 'tj',
  republicofthecongo: 'cg',
  republicofthegambia: 'gm',
  republicofthemaldives: 'mv',
  republicofthemarshallislands: 'mh',
  republicofthephilippines: 'ph',
  republicofthesudan: 'sd',
  republicoftheunionofmyanmar: 'mm',
  republicoftrinidadandtobago: 'tt',
  republicoftunisia: 'tn',
  republicofturkey: 'tr',
  republicofturkiye: 'tr',
  republicofuganda: 'ug',
  republicofuzbekistan: 'uz',
  republicofvanuatu: 'vu',
  republicofyemen: 'ye',
  republicofzambia: 'zm',
  republicofzimbabwe: 'zw',
  republieksuriname: 'sr',
  republikademokratikatimorleste: 'tl',
  republikahrvatska: 'hr',
  republikangpilipinas: 'ph',
  republikaslovenija: 'si',
  republikasrbija: 'rs',
  republikayuburundi: 'bi',
  republikenfinland: 'fi',
  republikindonesia: 'id',
  republiksingapura: 'sg',
  republiquecentrafricaine: 'cf',
  republiquedecotedivoire: 'ci',
  republiquededjibouti: 'dj',
  republiquedeguinee: 'gn',
  republiquedeguineeequatoriale: 'gq',
  republiquedemadagascar: 'mg',
  republiquedemaurice: 'mu',
  republiquedesseychelles: 'sc',
  republiquedevanuatu: 'vu',
  republiquedhaiti: 'ht',
  republiquedubenin: 'bj',
  republiqueduburundi: 'bi',
  republiqueducameroun: 'cm',
  republiquedumali: 'ml',
  republiquedurwanda: 'rw',
  republiquedusenegal: 'sn',
  republiquedutchad: 'td',
  republiquefrancaise: 'fr',
  republiquegabonaise: 'ga',
  republiquetogolaise: 'tg',
  repubulikayurwanda: 'rw',
  respublikakazakhstan: 'kz',
  reunion: 're',
  reunionisland: 're',
  ribaberikikiribati: 'ki',
  ripablikblongvanuatu: 'vu',
  ripubliknaoero: 'nr',
  romania: 'ro',
  roumania: 'ro',
  royaumedebelgique: 'be',
  rumania: 'ro',
  russia: 'ru',
  russianfederation: 'ru',
  rwanda: 'rw',
  rzeczpospolitapolska: 'pl',
  sahrawiarabdemocraticrepublic: 'eh',
  saintbarthelemy: 'bl',
  sainthelena: 'sh',
  sainthelenaascensionandtristandacunha: 'sh',
  saintkittsandnevis: 'kn',
  saintlucia: 'lc',
  saintmartin: 'mf',
  saintmartinfrenchpart: 'mf',
  saintpierreandmiquelon: 'pm',
  saintvincentandthegrenadines: 'vc',
  sakartvelo: 'ge',
  saltanatuman: 'om',
  samoa: 'ws',
  samoaamelika: 'as',
  sankattansihanaislasmarianas: 'mp',
  sanmarino: 'sm',
  saotomeandprincipe: 'st',
  sarnam: 'sr',
  sathalanalatpaxathipataipaxaxonlao: 'la',
  saudi: 'sa',
  saudiarabia: 'sa',
  schweiz: 'ch',
  scotland: 'gb-sct',
  senegal: 'sn',
  serbia: 'rs',
  seychelles: 'sc',
  shqiperi: 'al',
  shqiperia: 'al',
  shqipnia: 'al',
  sierraleone: 'sl',
  singapore: 'sg',
  singapura: 'sg',
  sintmaarten: 'sx',
  sintmaartendutchpart: 'sx',
  slovakia: 'sk',
  slovakrepublic: 'sk',
  slovenia: 'si',
  slovenskarepublika: 'sk',
  socialistrepublicofvietnam: 'vn',
  solomonislands: 'sb',
  somalia: 'so',
  somersisles: 'bm',
  southafrica: 'za',
  southgeorgia: 'gs',
  southgeorgiaandthesouthsandwichislands: 'gs',
  southkorea: 'kr',
  southsudan: 'ss',
  spain: 'es',
  sranangron: 'sr',
  srbija: 'rs',
  srilanka: 'lk',
  stateoferitrea: 'er',
  stateofisrael: 'il',
  stateofkuwait: 'kw',
  stateoflibya: 'ly',
  stateofpalestine: 'ps',
  stateofqatar: 'qa',
  statodellacittadelvaticano: 'va',
  stbarthelemy: 'bl',
  sthelenaascensionandtristandacunha: 'sh',
  sudan: 'sd',
  suidafrika: 'za',
  suisse: 'ch',
  sultanateofoman: 'om',
  suomentasavalta: 'fi',
  suomi: 'fi',
  suriname: 'sr',
  svalbardandjanmayen: 'sj',
  svalbardandjanmayenislands: 'sj',
  svalbardogjanmayen: 'sj',
  svizra: 'ch',
  svizzera: 'ch',
  swatini: 'sz',
  swaziland: 'sz',
  sweden: 'se',
  swissconfederation: 'ch',
  switzerland: 'ch',
  syria: 'sy',
  syrianarabrepublic: 'sy',
  taiwan: 'tw',
  tajikistan: 'tj',
  tanezrofttutrimt: 'eh',
  tanzania: 'tz',
  tanzaniaunitedrepublicof: 'tz',
  tchad: 'td',
  teratriofnorfkailen: 'nf',
  territoiredesileswallisetfutuna: 'wf',
  territoryofchristmasisland: 'cx',
  territoryofnorfolkisland: 'nf',
  territoryofthecocoskeelingislands: 'cc',
  territoryofthefrenchsouthernandantarcticlands: 'tf',
  territoryofthewallisandfutunaislands: 'wf',
  tetaparaguai: 'py',
  tetavolivia: 'bo',
  thai: 'th',
  thailand: 'th',
  theabodeofpeace: 'bn',
  thebermudas: 'bm',
  theformeryugoslavrepublicofmacedonia: 'mk',
  thegambia: 'gm',
  theislandsofbermuda: 'bm',
  thenetherlands: 'nl',
  timor: 'tl',
  timorleste: 'tl',
  timorlorosae: 'tl',
  tocikiston: 'tj',
  togo: 'tg',
  togolese: 'tg',
  togoleserepublic: 'tg',
  tokelau: 'tk',
  tonga: 'to',
  trinidad: 'tt',
  trinidadandtobago: 'tt',
  tunisia: 'tn',
  tunisianrepublic: 'tn',
  turkey: 'tr',
  turkiye: 'tr',
  turkiyecumhuriyeti: 'tr',
  turkmenistan: 'tm',
  turksandcaicosislands: 'tc',
  tuvalu: 'tv',
  uae: 'ae',
  udzimawakomori: 'km',
  uganda: 'ug',
  uk: 'gb',
  ukraine: 'ua',
  ukrayina: 'ua',
  umbusoweswatini: 'sz',
  uniondescomores: 'km',
  unionofthecomoros: 'km',
  unitedarabemirates: 'ae',
  unitedkingdom: 'gb',
  unitedkingdomofgreatbritainandnorthernireland: 'gb',
  unitedmexicanstates: 'mx',
  unitedrepublicoftanzania: 'tz',
  unitedstates: 'us',
  unitedstatesminoroutlyingislands: 'um',
  unitedstatesofamerica: 'us',
  unitedstatesvirginislands: 'vi',
  uruguay: 'uy',
  usa: 'us',
  uzbekistan: 'uz',
  vanuatu: 'vu',
  vatican: 'va',
  vaticancity: 'va',
  vaticancitystate: 'va',
  venezuela: 've',
  venezuelabolivarianrepublicof: 've',
  vietnam: 'vn',
  virginislands: 'vg',
  virginislandsbritish: 'vg',
  virginislandsoftheunitedstates: 'vi',
  virginislandsus: 'vi',
  viti: 'fj',
  waitukubuli: 'dm',
  wales: 'gb-wls',
  wallisandfutuna: 'wf',
  westernsahara: 'eh',
  weswatini: 'sz',
  wuliwya: 'bo',
  wuliwyasuyu: 'bo',
  yemen: 'ye',
  yemenirepublic: 'ye',
  zambia: 'zm',
  zhongguo: 'cn',
  zhonghua: 'cn',
  zhonghuaminguo: 'tw',
  zhonghuarenmingongheguo: 'cn',
  zimbabwe: 'zw',
};

/** Flag code (e.g. "tr", "gb-eng") for a team/country name, or null if unknown. */
export function flagCodeForTeam(name: string): string | null {
  if (!name) return null;
  return FLAG_CODE_BY_COUNTRY[normalizeCountry(name)] ?? null;
}

/** App-relative flag path (e.g. "/flags/tr.svg") for a team name, or null. */
export function flagPathForTeam(name: string): string | null {
  const code = flagCodeForTeam(name);
  return code ? `/flags/${code}.svg` : null;
}

/**
 * Absolute flag URL for a team name, or null. Remotion Lambda renders remotely
 * and cannot resolve app-relative paths, so props must carry absolute URLs.
 */
export function flagUrlForTeam(name: string, baseUrl: string): string | null {
  const p = flagPathForTeam(name);
  if (!p) return null;
  return `${baseUrl.replace(/\/$/, '')}${p}`;
}
